
import {Constants,ArrayUtil} from '../Constants';
import { CoordGeodetic } from '../../service/coord-helper.service';
import { FdmPlugin, FdmPluginInterface } from './plugins';
import { A, STATE, TURN } from '../States';

const Cesium = (<any>window).Cesium;


export class PointcloudController extends FdmPlugin implements FdmPluginInterface {

    debug:boolean = Constants.debug_off;

    static meta = {

        label: 'PLUGINS.POINTCLOUDER.LABEL',
        name: 'pointcloud-controller',
        translator: 'PLUGINS.POINTCLOUDER',
        tooltip: 'PLUGINS.POINTCLOUDER.TOOLTIP',
        
        // monitor a shortcut for this plugin
        shortcut: false,
        icon: 'braille',
        
        category: FdmPlugin.category.technical,
        types: [ FdmPlugin.types.transformController ],

        // we service laslaz/laslaz_tiles (pointclouds) and tms (terrain models)
        ds_types: [ FdmPlugin.ds_types.laslaz, FdmPlugin.ds_types.laslaz_tiles ],

        // Transform type
        tr_types: [ FdmPlugin.tr_types.three_d_tiles, FdmPlugin.tr_types.terrain_tiles ],
        
        // One per item
        cardinality: FdmPlugin.cardinality.one,
    };
        
    // Controls
    controls:any = {

        pointSize: { value:1, type:'slider', min:0.5, max:20, step:0.01, name:this.meta.translator+'.POINTSIZE'  },

        lighting: { value:true, type:'check', name:this.meta.translator+'.LIGHTING' },
        lightingStrength: { value:1, type:'slider', min:0, max:10, step:0.01, noshow:true, name:this.meta.translator+'.LIGHTINGSTRENGTH' },
        lightingRadius: { value:1, type:'slider', min:0, max:10, step:0.01, noshow:true, name:this.meta.translator+'.LIGHTINGRADIUS' },
        
        attenuation: { value:true, type:'check', name:this.meta.translator+'.ATTENUATION' },
        attenuationErrorScale: { value:1, type:'slider', min:0.1, max:2, step:0.01, noshow:true, name:this.meta.translator+'.ATTENUATIONERRORSCALE' },
        attenuationBase: { value:0, type:'slider', min:0, max:10, step:0.01, noshow:true , name:this.meta.translator+'.ATTENUATIONBASE'},
        attenuationMax: { value:0, type:'slider', min:0, max:32, step:1, noshow:true, name:this.meta.translator+'.ATTENUATIONMAX' },

        culling: { value:false, type:'check', group:'advanced', name:this.meta.translator+'.CULLING' },
        screenSpaceError: { value:4, type:'slider', min:1, max:64, step:0.01, group:'advanced', name:this.meta.translator+'.SCREENSPACEERROR' },

    }

    show:boolean = true;

    viewer:any = null;


    objectInjected () {

        this.viewer = this.services.mapService.viewer;

        // we've overridden this, but we want to do some default stuff
        super.objectInjected ();

        if ( this.debug ) { console.log ( '%c pointclouder.plugin %c objectInjected()', this.debugPrimary, this.debugSecondary, this.object ); }
                

    }

    end() {

    }

    refresh( newvalue = null, section:any = null ) {

        // check in with mama
        super.refresh ( newvalue, section );
        
        // start
        if ( this.show ) {

            // whatever entity we're colorizing
            if ( this.object ) {

                this.object.maximumScreenSpaceError = this.controls.screenSpaceError.value;
                this.object.pointCloudShading.backFaceCulling = this.controls.culling.value;
                
                if ( this.object.style ) {
                    this.object.style.pointSize = this.controls.pointSize.value;
                } else {
                    this.object.style = new Cesium.Cesium3DTileStyle({ pointSize: this.controls.pointSize.value });
                }

                this.object.pointCloudShading.attenuation = this.controls.attenuation.value;
                if ( this.controls.attenuation.value ) {
                    this.turnOn ([ 'attenuationErrorScale','attenuationErrorScale','attenuationMax' ]);
                    this.object.pointCloudShading.geometricErrorScale = this.controls.attenuationErrorScale.value;
                    this.object.pointCloudShading.baseResolution = this.controls.attenuationErrorScale.value;
                    this.object.pointCloudShading.maximumAttenuation = this.controls.attenuationMax.value;
                } else {
                    this.turnOff ([ 'attenuationErrorScale','attenuationErrorScale','attenuationMax' ]);
                }

                this.object.pointCloudShading.eyeDomeLighting = this.controls.lighting.value;
                if ( this.controls.lighting.value ) {
                    this.turnOn ([ 'lightingStrength','lightingRadius' ]);
                    this.object.pointCloudShading.eyeDomeLightingStrength = this.controls.lightingStrength.value;
                    this.object.pointCloudShading.eyeDomeLightingRadius = this.controls.lightingRadius.value;
                } else {
                    this.turnOff ([ 'lightingStrength','lightingRadius' ]);
                }

                if ( this.debug ) { console.log ( '%c pointclouder.plugin %c refresh() found object', this.debugPrimary, this.debugSecondary ); }
                
            }

        // stop
        } else {

                // reset colors
                // this.object.style = new Cesium.Cesium3DTileStyle({ color: '${COLOR}' });

            if ( this.debug ) { console.log ( '%c pointclouder.plugin %c refresh() stop', this.debugPrimary, this.debugSecondary, this.show ); }

        }
    }

}
